import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { MarketingLayout } from "@/components/MarketingLayout";
import { track } from "@/lib/analytics";

/**
 * Stripe redirects here after a successful checkout. Sign-in is handled by
 * WorkOS — the customer's email is already in WorkOS (the Stripe webhook
 * created the Customer + Subscription against it), so a single redirect
 * through /api/auth/login lets them sign in with the same address and land
 * on the dashboard with their subscription active.
 */
export default function AuthCheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (sessionId) track("checkout_completed", { session_id: sessionId });
    const id = window.setTimeout(() => {
      window.location.href = "/api/auth/login?next=%2Fdashboard";
    }, 1500);
    return () => window.clearTimeout(id);
  }, [sessionId]);

  return (
    <MarketingLayout>
      <div className="mx-auto flex w-full max-w-md flex-col items-center px-6 py-24 text-center">
        <CheckCircle2 className="h-10 w-10 text-emerald-600" />
        <h1 className="mt-4 text-2xl font-semibold tracking-tight text-slate-900">
          Payment received
        </h1>
        <p className="mt-2 text-sm text-slate-600">
          Redirecting you to sign in…
        </p>
      </div>
    </MarketingLayout>
  );
}
